import * as React from "react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";
import { humanizeSupabaseError } from "@/lib/supabase-errors";

function safeSonnerMessage(message: unknown) {
  if (typeof message === "string" || message instanceof Error) {
    return humanizeSupabaseError(message);
  }
  return message;
}

const toast = Object.assign(sonnerToast, {
  error: (message: Parameters<typeof sonnerToast.error>[0], data?: Parameters<typeof sonnerToast.error>[1]) =>
    sonnerToast.error(safeSonnerMessage(message) as Parameters<typeof sonnerToast.error>[0], data),
});

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      offset={16}
      mobileOffset={12}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background/95 group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-md group-[.toaster]:backdrop-blur-sm max-sm:py-2 max-sm:px-3 max-sm:text-sm max-sm:[--width:calc(100vw-1.5rem)]",
          title: "group-[.toast]:text-sm max-sm:group-[.toast]:text-xs group-[.toast]:font-medium",
          description: "group-[.toast]:text-muted-foreground max-sm:group-[.toast]:text-[11px]",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
